<template>
    <Modal
        class="wrap"
        v-model="modal"
        :title="$t('pages.setting.openEnterprise')"
        :mask-closable="false"
        :closable="false"
        width="387">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
            <FormItem :label="$t('pages.setting.enterpriseName')" prop="name">
                <Input v-model="formValidate.name" :placeholder="$t('pages.setting.inputEnterpriseName')"></Input>
            </FormItem>
            <FormItem :label="$t('pages.setting.industry')" prop="business_id">
                <Select v-model="formValidate.business_id" size="large" :placeholder="$t('common.select')" transfer>
                    <Option v-for="(item, index) in list" :key="index" :value="item.rowid">{{ item.text[lang]?item.text[lang]:item.text._ }}</Option>
                </Select>
            </FormItem>
        </Form>
        <div slot="footer" style="margin-right: 15%;">
            <Button type="default" @click="cancel">{{$t('common.cancel')}}</Button>
            <Button type="primary" :loading="loading" @click="submit">{{$t('common.confirm')}}</Button>
        </div>
    </Modal> 
</template>
<script>
    export default {
        name: "",
        mixins: [],
        components: {},
        props: {
            show: {
                default: false
            },
            type: {
                default: 'add'
            },
            apply: {
                default: () => {
                    return {
                        organization_name: ''
                    }
                }
            }
        },
        data () {
            return {
                modal: false,
                loading: false,
                formValidate: {
                    name: '',
                    business_id: ''
                },
                list: []
            }
        },
        computed: {
            ruleValidate() {
                return {
                    name: [
                        { required: true, message: this.$t('pages.setting.inputEnterpriseName'), trigger: 'blur' },
                        { type: 'string', max: 32, message: this.$t('common.upTo32Characters'), trigger: 'blur' }
                    ],
                    business_id: [
                        { required: true, type: 'number', message: this.$t('common.select'), trigger: 'blur' }
                    ]
                }
            },
            lang() {
                return this.$store.state.lang
            }
        },
        watch: {
            show(val) {
                this.modal = val
                if (this.type === 'edit') {
                    this.formValidate.name = this.apply.organization_name
                }
            }
        },
        methods: {
            cancel() {
                this.formValidate = {
                    name: '',
                    business_id: ''
                }

                this.$refs['formValidate'].resetFields();
                this.$emit('cancel')
            },
            submit() {
                this.$refs['formValidate'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        if (this.type === 'add') {
                            this.$api.post('organizations', this.formValidate).then(() => {
                                this.$Message.success('Success!');
                                this.$emit('confirm')
                                this.cancel()
                            }).catch(() => {}).finally(() => {
                                this.loading = false
                            })
                        } else if (this.type === 'edit') {
                            //
                            this.loading = false
                        }
                    }
                })
            }
        },
        created() {},
        mounted() {
            this.$api.get('specifications/business/list').then(({ data }) => {
                this.list = data
            })
        }
    }
</script>
<style scoped>
    
</style>